import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import vacunasReducer from "./features/vacunasSlice";
import patientReducer from "./features/patientSlice";
import paymentReducer from "./features/paymentSlice";
import antecedentReducer from "./features/antecedentsSlice";
import citaReducer from "./features/citasSlice";
import visitaReducer from "./features/visitasSlice";
import recetaReducer from "./features/recetaSlice";
import estudioReducer from "./features/estudiosSlice";
import notificationReducer from "./features/notificationSlice";
import configurationReducer from "./features/configurationSlice";
import registroVacunasReducer from "./features/registroVacunasSlice";
import documentosReducer from "./features/documentosSlice";
import templateReducer from "./features/templateSlice";
import gruposLaboratoriosReducer from "./features/gruposLaboratoriosSlice";
import laboratorios2Reducer from "./features/laboratorios2Slice";
import resultadoReducer from "./features/resultadosSlice";
import authReducer from "./features/authSlice";
import vaccineOrderReducer from "./features/vaccineOrderSlice";
import loggerReducer from "./features/loggerSlice";
import chatReducer from "./features/chatSlice";

export const store = configureStore({
  reducer: {
    chat: chatReducer,
    patient: patientReducer,
    payment: paymentReducer,
    antecedent: antecedentReducer,
    cita: citaReducer,
    visita: visitaReducer,
    receta: recetaReducer,
    estudio: estudioReducer,
    notification: notificationReducer,
    configuration: configurationReducer,
    registroVacunas: registroVacunasReducer,
    vacunas: vacunasReducer,
    documentos: documentosReducer,
    templates: templateReducer,
    gruposLaboratorios: gruposLaboratoriosReducer,
    laboratorios2: laboratorios2Reducer,
    resultados: resultadoReducer,
    auth: authReducer,
    vaccineOrder: vaccineOrderReducer,
    logger: loggerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignora acciones que comúnmente contienen datos no serializables
        ignoredActions: [
          "logger/addLog",
          "logger/addPendingLog",
          "logger/updateLog",
          "citas/updateCita/fulfilled",
          "citas/getCitas/fulfilled",
          "visitas/updateVisita/fulfilled",
          "patient/getPatients/fulfilled",
        ],
        // Ignora paths donde pueden haber datos no serializables
        ignoredPaths: [
          "logger.logs",
          "logger.pendingLogs",
          "citas.data", // Ajusta según tu estructura real
          "visitas.data",
          "patient.data",
          "receta.data",
          "estudio.data",
        ],
        // Aumenta el threshold para reducir warnings
        warnAfter: 100,
      },
      immutableCheck: {
        // También aumenta el threshold para immutableCheck
        warnAfter: 100,
      },
    }),
});

setupListeners(store.dispatch);
